import React  from 'react';
import { Route,Switch} from 'react-router-dom';

import TopIssuedBookReport from './topIssuedBookReport';  
import TopStudentReadBookReport from './topStudentReadBookReport';
export  const ReportLibraryRoutes = [
    {
        path: '/library-top-books-report',
        name:'Top Issued Books',
        component:TopIssuedBookReport,
        show:true,
    },
    {
        path: '/top-reader-report',
        name:'Top Reader',
        component:TopStudentReadBookReport,
        show:true,
    }, 
];

const ReportLibrary = (props) => {
    return(
        <Switch>
            {ReportLibraryRoutes.map((route) => 
                <Route exact
                    key={route.path}
                    path={`${props.match.url}${route.path}`}
                    component={route.component}
                />
            )} 
        </Switch> );
};
export default ReportLibrary; 


// WEBPACK FOOTER //
// ./src/components/Reports/LibraryReport/index.js